import Carousel from "react-bootstrap/Carousel";
import "./carousel.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container } from "react-bootstrap";

function DarkVariantExample() {
  return (
    <Container className="w-100 p-0" fluid>
      <Col>
        <Carousel interval={2000}>
          <Carousel.Item>
            <img className="d-block w-100 " src='/assets/images/slider.jpg' alt="First slide" />
            <Carousel.Caption>
              <h5>Currency Growth Financial Services</h5>
              <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src='/assets/images/carousel_2.jpg' alt="Second slide" />
            <Carousel.Caption className="  d-sm-block">
              <div className="d-sm-block ">
                <h5 className="">Currency Growth Financial Services</h5>
                <p className="text-center">
                  My commitment to the world of finance is rooted in a desire to
                  contribute to the greater good. I believe that financial
                  systems, when harnessed thoughtfully, have the power to
                  transform lives and uplift communities. My passion lies in
                  architecting solutions that not only meet immediate needs but
                  also foster long-term sustainability.
                </p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src='/assets/images/slider4.jpg' alt="Third slide" />
            <Carousel.Caption>
              <h5>Currency Growth Financial Services</h5>
              <p className="text-center">
              Tailored financing solutions for businesses of all sizes. Enjoy competitive rates, streamlined processes, and customized repayment terms.
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src='/assets/images/about11.jpeg' alt="Third slide" />
            <Carousel.Caption>
              <h5>Currency Growth Financial Services</h5>
              <p className="text-center">
              Accessible personal financing options with low credit score requirements. Empower your financial goals with simplified online applications.
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src='/assets/images/slider6.jpg' alt="Third slide" />
            <Carousel.Caption>
              <h5>Currency Growth Financial Services</h5>
              <p className="text-center">
              Partner with a fintech platform designed to streamline lending. Experience a seamless journey toward achieving your financial ambitions.
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </Col>
    </Container>
  );
}

export default DarkVariantExample;
